import { useState, useEffect } from "react";
import "./randomthings.css";
import useScrollReveal from "../hooks/useScrollReveal.js";

const TEXT_COLORS = [
  { label: "White", value: "#ffffff" },
  { label: "Slate", value: "#94a3b8" },
  { label: "Navy",  value: "#60a5fa" },
  { label: "Green", value: "#4ade80" },
  { label: "Lime",  value: "#d9f99d" },
];

export default function PortfolioWidget({ introDone }) {
  const [selectedColor, setSelectedColor] = useState(0);
  const [clock, setClock] = useState("");
  const [ref, visible] = useScrollReveal(introDone, { threshold: 0.1 });

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--theme-text",
      TEXT_COLORS[selectedColor].value
    );
  }, [selectedColor]);

  useEffect(() => {
    const tick = () =>
      setClock(
        new Date().toLocaleTimeString("en-GB", {
          timeZone: "Europe/Belgrade",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        })
      );
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  const titleColor = TEXT_COLORS[selectedColor].value;

  return (
    <div
      ref={ref}
      className={`pw-widget reveal ${visible ? "reveal-visible" : ""}`}
    >

      {/* ── THEME CARD ── */}
      <div
        className="pw-card"
        style={{
          "--card-delay": "0s",
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(24px)",
          transition: "opacity 0.6s ease 0s, transform 0.6s cubic-bezier(0.22,1,0.36,1) 0s"
        }}
      >
        <div className="pw-card-title" style={{ color: titleColor }}>
          <PaletteIcon />
          Text Theme
        </div>
        <div className="pw-color-grid">
          {TEXT_COLORS.map((c, i) => (
            <div
              key={i}
              className={`pw-swatch${i === selectedColor ? " selected" : ""}`}
              style={{ background: c.value }}
              title={c.label}
              onClick={() => setSelectedColor(i)}
            />
          ))}
        </div>
        <div className="pw-color-label">{TEXT_COLORS[selectedColor].label}</div>
      </div>

     {/* ── CONNECT CARD ── */}
<div
  className="pw-card"
  style={{
    opacity: visible ? 1 : 0,
    transform: visible ? "translateY(0)" : "translateY(24px)",
    transition: "opacity 0.6s ease 0.12s, transform 0.6s cubic-bezier(0.22,1,0.36,1) 0.12s"
  }}
>
  <div className="pw-card-title" style={{ color: titleColor }}>
    <CalendarIcon />
    Let's Connect
  </div>
  <p className="pw-connect-text">
    Always open to interesting projects and conversations.
  </p>
  
   <a href="mailto:amarbraha1@email.com?subject=Let's%20Chat&body=Hi%20Amar%2C%20I'd%20love%20to%20connect!"
    className="pw-chat-btn"
  >
    <CalendarIcon />
    Book a Chat
  </a>
</div>
      {/* ── LOCATION CARD ── */}
      <div
        className="pw-card"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(24px)",
          transition: "opacity 0.6s ease 0.24s, transform 0.6s cubic-bezier(0.22,1,0.36,1) 0.24s"
        }}
      >
        <div className="pw-card-title" style={{ color: titleColor }}>
          <PinIcon />
          Currently Based In
          <span style={{ marginLeft: "auto", fontSize: 13 }}>📍</span>
        </div>
        <div className="pw-map-area">
          <svg viewBox="0 0 200 110" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", display: "block" }}>
            <rect width="200" height="110" fill="#1a1b2e" />
            <g stroke="#2a2b3d" strokeWidth="0.5" opacity="0.8">
              <line x1="0" y1="18" x2="200" y2="22" /><line x1="0" y1="35" x2="200" y2="30" />
              <line x1="0" y1="50" x2="200" y2="55" /><line x1="0" y1="68" x2="200" y2="64" />
              <line x1="0" y1="82" x2="200" y2="85" /><line x1="0" y1="95" x2="200" y2="92" />
              <line x1="20" y1="0" x2="25" y2="110" /><line x1="45" y1="0" x2="48" y2="110" />
              <line x1="70" y1="0" x2="68" y2="110" /><line x1="95" y1="0" x2="98" y2="110" />
              <line x1="125" y1="0" x2="122" y2="110" /><line x1="150" y1="0" x2="155" y2="110" />
              <line x1="178" y1="0" x2="175" y2="110" />
            </g>
            <g fill="#22233a" opacity="0.7">
              <rect x="26" y="23" width="20" height="11" rx="1" /><rect x="49" y="31" width="17" height="18" rx="1" />
              <rect x="26" y="36" width="20" height="13" rx="1" /><rect x="72" y="23" width="22" height="10" rx="1" />
              <rect x="100" y="30" width="20" height="22" rx="1" /><rect x="127" y="22" width="26" height="10" rx="1" />
              <rect x="156" y="31" width="18" height="15" rx="1" /><rect x="26" y="56" width="18" height="10" rx="1" />
              <rect x="49" y="56" width="17" height="7" rx="1" /><rect x="72" y="56" width="22" height="6" rx="1" />
              <rect x="100" y="56" width="20" height="7" rx="1" /><rect x="127" y="57" width="26" height="6" rx="1" />
              <rect x="26" y="70" width="40" height="13" rx="1" /><rect x="72" y="66" width="22" height="17" rx="1" />
              <rect x="100" y="66" width="20" height="18" rx="1" /><rect x="127" y="66" width="26" height="17" rx="1" />
              <rect x="156" y="66" width="18" height="17" rx="1" /><rect x="26" y="87" width="18" height="8" rx="1" />
              <rect x="49" y="87" width="17" height="8" rx="1" /><rect x="72" y="87" width="22" height="8" rx="1" />
              <rect x="100" y="87" width="20" height="8" rx="1" /><rect x="127" y="87" width="26" height="8" rx="1" />
            </g>
            <g stroke="#2e3050" strokeWidth="2">
              <line x1="0" y1="55" x2="200" y2="55" /><line x1="98" y1="0" x2="98" y2="110" />
            </g>
            <circle cx="98" cy="52" r="5" fill="#f38ba8" opacity="0.9" />
            <circle cx="98" cy="52" r="2.5" fill="#fff" />
            <text x="106" y="49" fontFamily="monospace" fontSize="7" fill="#cdd6f4" opacity="0.9">Prizren</text>
          </svg>
        </div>
        <div className="pw-map-footer">
          <span>Prizren, XK</span>
          <span className="pw-clock">
            <span className="pw-clock-dot" />
            {clock}
          </span>
        </div>
      </div>

    </div>
  );
}

function PaletteIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <circle cx="8" cy="8" r="6" />
      <circle cx="8" cy="5" r="1" fill="currentColor" stroke="none" />
      <circle cx="11" cy="9.5" r="1" fill="currentColor" stroke="none" />
      <circle cx="5" cy="9.5" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}

function CalendarIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="2" y="3" width="12" height="10" rx="1.5" />
      <path d="M2 6h12" />
      <path d="M5 3V2M11 3V2" />
    </svg>
  );
}

function PinIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M8 2C5.79 2 4 3.79 4 6c0 3.5 4 8 4 8s4-4.5 4-8c0-2.21-1.79-4-4-4z" />
      <circle cx="8" cy="6" r="1.5" />
    </svg>
  );
}